/** Visual tokens copied from events-staff (StaffEventDetails / EventAttendeesDashboard). */

export const SECTION_TITLE =
  "text-lg leading-none font-medium text-gray-font font-decimal-medium mb-4";

export const PANEL = "p-4 rounded border border-gray-200";

export const TABLE_HEAD =
  "border border-gray-200 bg-accent-Default-dark px-3 py-2 text-left text-xs font-semibold text-white";

export const TABLE_HEAD_RIGHT = `${TABLE_HEAD} text-right`;

export const TABLE_CELL = "border border-gray-200 px-3 py-2";

export const TABLE_ROW = "even:bg-gray-50";
